/* ==========================================================================
   MYAPIN — Custom Cart Drawer behaviour  (v2: robust variant switching)
   ========================================================================== */
(function () {
  'use strict';

  var SECTION_ID = 'custom-cart-drawer';
  var TIMER_KEY = 'ccd_timer_end';

  var R = window.routes || {};
  var ROOT = (R.root_url && R.root_url !== '/') ? R.root_url.replace(/\/$/, '') : '';
  var URL_ADD = R.cart_add_url || (ROOT + '/cart/add');
  var URL_CHANGE = R.cart_change_url || (ROOT + '/cart/change');

  function sectionUrl() { return window.location.pathname; }
  function norm(v) { return String(v == null ? '' : v).trim(); }

  /* ----- Networking ------------------------------------------------------ */
  function postJSON(url, payload) {
    payload.sections = SECTION_ID;
    payload.sections_url = sectionUrl();
    return fetch(url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function fetchSectionHTML() {
    return fetch(ROOT + '/?sections=' + SECTION_ID, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { return data[SECTION_ID]; });
  }

  /* ----- The element ----------------------------------------------------- */
  var Drawer = {
    el: null, panel: null, inner: null, timerInterval: null, minutes: 10,

    init: function (el) {
      this.el = el;
      this.panel = el.querySelector('[data-ccd-panel]');
      this.inner = el.querySelector('[data-ccd-inner]');
      this.minutes = parseInt(el.getAttribute('data-timer-minutes'), 10) || 10;

      el.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && el.getAttribute('aria-hidden') === 'false') Drawer.close();
      });

      this.fitTitle();
      window.addEventListener('resize', this.fitTitle.bind(this));

      this.enhance();
      this.startTimerLoop();
    },

    /* ----- Open / close ----- */
    open: function () {
      var self = this;
      fetchSectionHTML().then(function (html) {
        if (html) self.swap(html);
        self.show();
      }).catch(function () { self.show(); });
    },
    show: function () {
      this.el.setAttribute('aria-hidden', 'false');
      this.lockScroll(true);
      var close = this.el.querySelector('[data-ccd-close]');
      if (close) close.focus();
    },
    close: function () {
      this.el.setAttribute('aria-hidden', 'true');
      this.lockScroll(false);
    },
    lockScroll: function (on) {
      document.body.style.overflow = on ? 'hidden' : '';
    },

    /* ----- Delegated clicks ----- */
    onClick: function (e) {
      if (e.target.closest('[data-ccd-overlay]') || e.target.closest('[data-ccd-close]')) { this.close(); return; }
      var toggle = e.target.closest('[data-ccd-discount-toggle]');
      if (toggle) { this.toggleDiscount(toggle); return; }
      var item = e.target.closest('[data-ccd-item]');
      if (!item) return;
      if (e.target.closest('[data-ccd-plus]'))  { this.changeQty(item, +1); return; }
      if (e.target.closest('[data-ccd-minus]')) { this.changeQty(item, -1); return; }
      if (e.target.closest('[data-ccd-remove]')) { this.setQty(item, 0); return; }
    },

    /* ----- Quantity ----- */
    changeQty: function (item, delta) {
      var current = parseInt(item.getAttribute('data-quantity'), 10) || 1;
      this.setQty(item, Math.max(0, current + delta));
    },
    setQty: function (item, qty) {
      var key = item.getAttribute('data-line-key');
      item.setAttribute('data-ccd-busy', '');
      postJSON(URL_CHANGE, { id: key, quantity: qty }).then(this.render.bind(this));
    },

    /* ----- Discount caret ----- */
    toggleDiscount: function (toggle) {
      var wrap = toggle.closest('[data-ccd-discount]');
      var box = wrap.querySelector('[data-ccd-discount-breakdown]');
      var open = wrap.hasAttribute('data-open');
      if (open) { wrap.removeAttribute('data-open'); box.hidden = true; toggle.setAttribute('aria-expanded', 'false'); }
      else { wrap.setAttribute('data-open', ''); box.hidden = false; toggle.setAttribute('aria-expanded', 'true'); }
    },

    /* ----- Checkout ----- */
    checkout: function (btn) {
      if (btn.hasAttribute('data-loading')) return;
      btn.setAttribute('data-loading', '');
      window.location.href = ROOT + '/checkout';
    },

    /* ----- Variant data helpers ----- */
    readVariantData: function (item) {
      var el = item.querySelector('[data-ccd-variant-data]');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    },
    readChosen: function (item) {
      var chosen = [];
      item.querySelectorAll('[data-ccd-option-index]').forEach(function (s) {
        chosen[parseInt(s.getAttribute('data-ccd-option-index'), 10)] = norm(s.value);
      });
      return chosen;
    },
    findVariant: function (data, chosen) {
      if (!data || !data.variants) return null;
      var n = data.optionCount || chosen.length;
      return data.variants.find(function (v) {
        var vo = [v.o1, v.o2, v.o3];
        for (var i = 0; i < n; i++) { if (norm(vo[i]) !== norm(chosen[i])) return false; }
        return true;
      }) || null;
    },

    /* ----- Variant swap: serialized, Shopify is the source of truth ----- */
    swapVariant: function (item, select) {
      var self = this;
      var data = this.readVariantData(item);
      var chosen = this.readChosen(item);
      var target = this.findVariant(data, chosen);

      // No such combination exists, or it's flagged unavailable → don't switch.
      if (!target) { this.revertSelect(item, select, 'That combination isn\u2019t available.'); return; }
      if (target.available === false) { this.revertSelect(item, select, 'That option is sold out.'); return; }
      // Same variant as the line already is → nothing to do.
      if (String(target.id) === String(item._variantId)) return;
      // One swap at a time — prevents overlapping add/remove from emptying the cart.
      if (this._swapping) { this.revertSelect(item, select); return; }
      this._swapping = true;

      var key = item.getAttribute('data-line-key');
      var qty = parseInt(item.getAttribute('data-quantity'), 10) || 1;
      item.setAttribute('data-ccd-busy', '');

      // Add the new variant first; only remove the old line if that succeeds.
      postJSON(URL_ADD, { id: target.id, quantity: qty })
        .then(function (addResp) {
          if (addResp && addResp.status) {            // Shopify says no (sold out / not purchasable)
            item.removeAttribute('data-ccd-busy');
            self.revertSelect(item, select, 'That option is sold out.');
            self._swapping = false;
            return null;
          }
          return postJSON(URL_CHANGE, { id: key, quantity: 0 }).then(function (resp) {
            self.render(resp);
            self._swapping = false;
          });
        })
        .catch(function () { item.removeAttribute('data-ccd-busy'); self._swapping = false; self.refresh(); });
    },

    revertSelect: function (item, select, message) {
      if (select && select._prev != null) select.value = select._prev;
      if (message) this.flashNote(item, message);
    },
    flashNote: function (item, message) {
      var body = item.querySelector('.ccd__item-body') || item;
      var note = item.querySelector('.ccd__note');
      if (!note) { note = document.createElement('span'); note.className = 'ccd__note'; body.appendChild(note); }
      note.textContent = message;
      clearTimeout(note._t);
      note._t = setTimeout(function () { if (note && note.parentNode) note.parentNode.removeChild(note); }, 3000);
    },

    /* ----- Render ----- */
    render: function (resp) {
      var html = resp && resp.sections && resp.sections[SECTION_ID];
      if (html) this.swap(html); else this.refresh();
    },
    refresh: function () {
      var self = this;
      fetchSectionHTML().then(function (html) { if (html) self.swap(html); });
    },
    swap: function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ccd-inner]');
      if (fresh) this.inner.innerHTML = fresh.innerHTML;
      this.enhance();
      this.updateTimerDisplay();
    },

    /* ----- Post-render: bind selects, remember current variant ----- */
    enhance: function () {
      this.inner = this.el.querySelector('[data-ccd-inner]');
      var self = this;

      this.el.querySelectorAll('[data-ccd-item]').forEach(function (item) {
        var data = self.readVariantData(item);
        // Remember which variant this line currently is (from its rendered selects)
        var current = self.findVariant(data, self.readChosen(item));
        item._variantId = current ? current.id : null;

        item.querySelectorAll('[data-ccd-option-index]').forEach(function (select) {
          select._prev = select.value;                 // for graceful revert
          if (!select._ccdBound) {
            select._ccdBound = true;
            select.addEventListener('change', function () { self.swapVariant(item, select); });
          }
        });

        self.labelSoldOut(item, data);                 // soft labels, never disables
      });

      var btn = this.el.querySelector('[data-ccd-checkout]');
      if (btn && !btn._ccdBound) { btn._ccdBound = true; btn.addEventListener('click', function () { self.checkout(btn); }); }
    },

    // Add a " — sold out" hint to option values that are unavailable, but only
    // when the data is meaningful (some available, some not). Never disables,
    // so valid picks always go through and Shopify makes the final call.
    labelSoldOut: function (item, data) {
      if (!data) return;
      var anyAvailable = data.variants.some(function (v) { return v.available; });
      if (!anyAvailable) return;                        // oversell / untracked store → no labels

      var selects = item.querySelectorAll('[data-ccd-option-index]');
      var chosen = this.readChosen(item);
      var self = this;
      selects.forEach(function (select) {
        var idx = parseInt(select.getAttribute('data-ccd-option-index'), 10);
        Array.prototype.forEach.call(select.options, function (opt) {
          var candidate = chosen.slice();
          candidate[idx] = norm(opt.value);
          var hit = self.findVariant(data, candidate);
          var soldOut = hit && hit.available === false;
          var base = norm(opt.value);
          opt.textContent = soldOut ? (base + ' \u2014 sold out') : base;
          opt.disabled = false;                          // always selectable
        });
      });
    },

    /* ----- Title auto-shrink ----- */
    fitTitle: function () {
      var t = this.el.querySelector('[data-ccd-title]');
      if (!t) return;
      t.style.fontSize = '';
      var size = parseFloat(getComputedStyle(t).fontSize);
      var guard = 0;
      while (t.scrollWidth > t.clientWidth && size > 14 && guard < 40) {
        size -= 0.5; t.style.fontSize = size + 'px'; guard++;
      }
    },

    /* ----- Reservation timer ----- */
    resetTimer: function () {
      var end = Date.now() + this.minutes * 60 * 1000;
      try { localStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
      this.updateTimerDisplay();
    },
    startTimerLoop: function () {
      var self = this;
      if (this.timerInterval) clearInterval(this.timerInterval);
      this.timerInterval = setInterval(function () { self.updateTimerDisplay(); }, 1000);
      this.updateTimerDisplay();
    },
    updateTimerDisplay: function () {
      var bar = this.el.querySelector('[data-ccd-timer]');
      var display = this.el.querySelector('[data-ccd-timer-display]');
      if (!bar || !display) return;
      var end = parseInt(localStorage.getItem(TIMER_KEY) || '0', 10);
      if (!end) { this.resetTimer(); return; }
      var remaining = Math.round((end - Date.now()) / 1000);
      if (remaining <= 0) { bar.hidden = true; return; }
      bar.hidden = false;
      var m = Math.floor(remaining / 60);
      var s = remaining % 60;
      display.textContent = m + ':' + (s < 10 ? '0' + s : s);
    }
  };

  /* ----- Global hooks ---------------------------------------------------- */
  function bindGlobal() {
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('#cart-icon-bubble, a[href$="/cart"], [data-ccd-open]');
      if (trigger && Drawer.el) { e.preventDefault(); Drawer.open(); }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (!Drawer.el) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var fd = new FormData(form);
      fd.append('sections', SECTION_ID);
      fd.append('sections_url', sectionUrl());

      fetch(URL_ADD + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (resp) {
          if (resp.status) return;
          Drawer.resetTimer();
          Drawer.render(resp);
          Drawer.show();
        })
        .catch(function () {});
    }, true);
  }

  function boot() {
    var el = document.querySelector('[data-ccd]');
    if (el && !el._ccdInit) { el._ccdInit = true; Drawer.init(el); }
    bindGlobal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
